module.exports = __webpack_public_path__ + "static/media/mxarchive_SK.51493c1b.md";